/**
 * Get cookie by name
 * @function
 * @param [name] {String} Cookie name
 * @returns {String}
 * @example getCookie('advertiser')
 */
export const getCookie = (name) => {
    const matches = document.cookie.match(
        new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[]\/+^])/g, '\\$1')}=([^;]*)`)
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
};

/**
 * Set cookie
 * @param [name] {String} Cookie name
 * @param [value] {String|Number} Cookie value
 * @param [options.expires] {Number} Define lifetime of the cookie in days.
 * @param [options.path] {String} Define the path where the cookie is valid. By default the path of the cookie is the path of the page where the cookie was created (standard browser behavior).
 * @param [options.domain] {String} Define the domain to which to apply the cookie.
 * @example setCookie('advertiser', { expires: 100, path: '/' })
 */
export const setCookie = (name, value, { expires = 365, path = '', domain = '' } = {}) => {
    let str = `${name}=${value}`;

    if (expires > 0) {
        const date = new Date();
        date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
        str += `; expires=${date.toUTCString()}`;
    }

    if (path) {
        str += `; path=${path}`;
    }

    if (domain) {
        str += `; domain=${domain}`;
    }

    document.cookie = str;
};

/**
 * Remove cookie
 * @param [name] {String} Cookie name
 * @param [options.path] {String} Define the path where the cookie is valid. By default the path of the cookie is the path of the page where the cookie was created (standard browser behavior).
 * @param [options.domain] {String} Define the domain to which to apply the cookie.
 * @example removeCookie('advertiser')
 */
export const removeCookie = (name, { path = '', domain = '' } = {}) => {
    let str = `${name}=''; expires=Fri, 01 Jan 2010 12:00:00 UTC`;

    if (path) {
        str += `; path=${path}`;
    }

    if (domain) {
        str += `; domain=${domain}`;
    }

    document.cookie = str;
};
